<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>学员培训</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="城市">
          <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable>
            <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
              :value="item.id + ''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="服务者姓名">
          <el-input v-model="listQuery.workerName" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="服务者编号">
          <el-input v-model="listQuery.workerNo" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="课程安排编号">
          <el-input v-model="listQuery.courseArrangementId" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="课程类型">
          <el-select v-model="listQuery.courseId" clearable placeholder="请选择" filterable>
            <el-option v-for="(item, index) in allCourseList" :key="index" :label="item.courseName"
              :value="item.id + ''"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="培训结果">
          <el-select v-model="listQuery.isPass" clearable placeholder="" filterable>
            <el-option v-for="(item, index) in isPassType" :key="index" :label="item" :value="index + ''"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-per="'xueyuanbaoming'" type="primary" class="el-icon-plus" plan
            @click="addStudy">学员报名</el-button>
        </el-form-item>

      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column prop="workerNo" label="服务者编号" width="120"></el-table-column>
        <el-table-column prop="workerName" label="服务者姓名" width="100"></el-table-column>

        <el-table-column prop="courseArrangement.id" label="课程安排编号" width="100"></el-table-column>
        <el-table-column prop="courseArrangement.courseName" label="课程名称" width="120"></el-table-column>
        <el-table-column prop="courseArrangement.lectureUserName" label="讲师" width="100"></el-table-column>
        <el-table-column prop="startTime" label="上课时间" width="150">
          <template slot-scope="scope">
            {{ formateTime(scope.row.courseArrangement.startTime) }}<br />
          </template>
        </el-table-column>
        <el-table-column prop="isPass" label="状态" width="100">
          <template slot-scope="scope">
            {{ isPassType[scope.row.isPass] }}
            <!-- <el-tag type="success" v-if="scope.row.state==0">开启</el-tag> -->
          </template>
        </el-table-column>

        <el-table-column prop="score" label="得分" width="80"></el-table-column>
        <el-table-column prop="scoreLevel" label="综合星级" width="80"></el-table-column>
        <el-table-column prop="comment" label="评价" width="150"></el-table-column>
        <el-table-column prop="raterName" label="评分人" width="100"></el-table-column>

        <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>

        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button v-per="'pingfen'" type="text" v-if="scope.row.isPass == 0" icon="el-icon-edit"
              @click="toScore(scope.row)">评分</el-button>
            <el-button v-per="'quxiaobaoke'" type="text" v-if="scope.row.isPass == 0" icon="el-icon-delete"
              @click="handleCancel(scope.$index, scope.row)">取消报课</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
    </el-card>

    <el-dialog title="评价得分" :visible.sync="showtoScore" width="720px" :close-on-click-modal="false" center>
      <el-form label-width="100px" inline>
        <el-row>
          <el-form-item label="学员姓名">
            <el-input v-model="tempRow.workerName" placeholder="" disabled></el-input>
          </el-form-item>
          <el-form-item label="课程">
            <el-input v-model="tempRow.courseArrangement.courseName" placeholder="" disabled></el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="得分">
            <el-input type="number" v-model="scoreForm.score" placeholder="请输入得分" clearable></el-input>
          </el-form-item>
          <el-form-item label="培训结果">
            <el-select v-model="scoreForm.isPass" clearable placeholder="请选择是否通过" filterable>
              <el-option label="通过" value="1"></el-option>
              <el-option label="未通过" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="评价或原因">
            <el-input v-model="scoreForm.comment" style="width:550px" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showtoScore = false">关闭</el-button>
        <el-button type="primary" @click="confirmScore()">确认</el-button>
      </span>
    </el-dialog>

    <!--创建订单 -->
    <studentTrainForm ref="studentTrainFormRef" />

  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
import studentTrainForm from "@/components/workercrm/compent/studentTrainForm.vue";

let vm;
export default {
  components: { Pagination, studentTrainForm },
  data() {
    return {
      isPassType: {
        0: "未评分",
        1: "通过",
        2: "未通过",
        3: "已取消",
      },
      cityList: [],
      listData: [],
      allCourseList: [], //课程
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        cityId: null,
        workerNo: null,
        workerName: null,
        courseId: null,
        courseArrangementId: null, //课程安排id
        isPass: null,
      },
      tempRow: { courseArrangement: {} },
      scoreForm: {
        id: null,

        isPass: null,
        score: null,
        comment: null,

        raterId: null,
        raterName: null,
      },
      showtoScore: false,
    };
  },
  activated() {
    console.log(this.$route.query);
    if (this.$route.query.courseArrangementId) {
      this.listQuery.courseArrangementId =
        this.$route.query.courseArrangementId;
    }
    this.querySearch();
  },

  async mounted() {
    // 确保所有数据加载完成后再调用addStudy
    await Promise.all([
      this.getAllCity(),
      this.getCourseGetAllCourseList()
    ]);

    if (this.$route.query.wokrerNo) {
      this.listQuery.workerNo = this.$route.query.wokrerNo;
      this.addStudy(this.$route.query.wokrerNo, this.$route.query.cityId, this.$route.query.workerName, this.allCourseList, this.cityList);
    }
    // 监听localStorage变化事件
    window.addEventListener('storage', this.handleStorageChange);

    // 检查是否有待处理的workerNo
    const storedWorkerNo = localStorage.getItem('studentTrainWorkerNo');
    if (storedWorkerNo) {
      this.listQuery.workerNo = storedWorkerNo;
      localStorage.removeItem('studentTrainWorkerNo');
    }

    this.querySearch();
  },

  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('storage', this.handleStorageChange);
  },

  methods: {
    // 监听localStorage变化
    handleStorageChange(event) {
      if (event.key === 'studentTrainWorkerNo' && event.newValue) {
        this.listQuery.workerNo = event.newValue;
        this.querySearch();
      }
    },
    getAllCity() {
      //城市下拉框
      return wmsApi.$axiosgetallCity({ userId: globalData.userInfo.id }).then((res) => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
        return res;
      });
    },
    handleCancel(index, row) {
      this.$confirm(
        "是否确认取消( " + row.workerName + " )报课?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          crmApi
            .$ajaxemEmCourseEnrolmentCancelCourse({
              id: row.id,
              updateUserId: globalData.userInfo.id,
            })
            .then((res) => {
              if (res.data.errno == 0) {
                this.$message.success("操作成功");
                this.querySearch();
              }
            });
        })
        .catch(() => { });
    },
    toScore(row) {
      this.showtoScore = true;
      this.tempRow = row;

      this.scoreForm = {
        id: row.id,

        isPass: null,
        score: null,
        comment: null,

        raterId: null,
        raterName: null,
      };
    },
    confirmScore() {
      if (this.scoreForm.score == null || this.scoreForm.score == "") {
        this.$message.error("请输入得分");
        return;
      }
      if (this.scoreForm.isPass == null || this.scoreForm.isPass == "") {
        this.$message.error("请选择培训结果");
        return;
      }
      if (
        this.scoreForm.isPass == 2 &&
        (this.scoreForm.comment == null || this.scoreForm.comment == "")
      ) {
        //如果未通过
        this.$message.error("请输入未通过原因");
        return;
      }
      this.scoreForm.raterId = globalData.userInfo.id;
      this.scoreForm.raterName = globalData.userInfo.userName;

      crmApi
        .$ajaxemEmCourseEnrolmentStudentScore(this.scoreForm)
        .then((res) => {
          if (res.data.errno == 0) {
            this.$message.success("操作成功");
            this.showtoScore = false;
            this.querySearch();
          }
        });
    },
    addStudy(workerNo, cityId, workerName) {
      //添加学员
      this.$refs.studentTrainFormRef.addStudy(workerNo, cityId, workerName, this.allCourseList, this.cityList);
    },

    //查询
    querySearch() {
      this.listQuery.pageSize = this.pageSize;
      this.listQuery.pageNum = this.currentPage;
      this.listQuery.userId = globalData.userInfo.id;
      crmApi
        .$ajaxemEmCourseEnrolmentGetPageList(this.listQuery)
        .then((res) => {
          if (res.data.errno == 0) {
            this.listData = res.data.data.list;
            this.total = res.data.data.total;
          }
        });
    },

    getCourseGetAllCourseList() {
      //获取课程
      return crmApi.$ajaxEmCourseGetAllCourseList().then((res) => {
        if (res.data.errno == 0) {
          this.allCourseList = res.data.data;
        }
        return res;
      });
    },
  },
  beforeCreate() {
    vm = this;
  },
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}

.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
</style>
